<div class="stories-carousel">
    <div class="stories-carousel__description">
        <h2 class="stories-carousel__header" [innerHTML]="block.data.header"></h2>
        <p class="stories-carousel__intro" [innerHTML]="block.data.intro"></p>
    </div>

    <div class="stories-carousel-slider-wrapper">
        <div class="stories-carousel-slider" [swiper]="slideConfig" (indexChange)="onIndexChange($event)">
            <div class="stories-carousel-slider__container">
                <div *ngFor="let block of block.content; trackBy: trackByFn;" class="stories-carousel-slider__item">
                    <div class="stories-carousel-slider__content">
                      <ng-container *ngIf="block.data.linkUrl && block.data.linkUrl.length > 1">
                        <a href="{{block.data.linkUrl}}" class="stories-carousel-slider__content-image-wrapper">
                          <div class="stories-carousel-slider__content-image" [ngStyle]="{backgroundImage: block.data.image ? parseImagePath(block.data.image) : null}"></div>
                        </a>
                      </ng-container>
                      <ng-container *ngIf="!block.data.linkUrl || block.data.linkUrl.length === 0">
                        <div class="stories-carousel-slider__content-image-wrapper">
                          <div class="stories-carousel-slider__content-image" [ngStyle]="{backgroundImage: block.data.image ? parseImagePath(block.data.image)  : null}"></div>
                        </div>
                      </ng-container>
                        <div class="stories-carousel-slider__content-text">
                            <blockquote class="stories-carousel-slider__blockquote">
                                <p class="stories-carousel-slider__blockquote-text" [innerHTML]="block.data.quote"></p>

                                <footer class="stories-carousel-slider__blockquote-footer" *ngIf="block.data.cite">
                                    <cite class="stories-carousel-slider__blockquote-cite">
                                        <span [outerHTML]="block.data.cite"></span>
                                    </cite>
                                </footer>
                            </blockquote>

                          <ng-container *ngIf="block.data.linkUrl && block.data.linkUrl.length > 1">
                            <a href="{{block.data.linkUrl}}" class="btn btn--text-style1" [innerHTML]="block.data.linkText"></a>
                          </ng-container>


                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="stories-carousel-controls">
            <div class="stories-carousel-controls__prev"></div>

            <div class="stories-carousel-controls__indicator-wrapper">
                <div class="stories-carousel-controls__indicator-dots"></div>
                <div class="stories-carousel-controls__indicator-text" aria-live="polite">
                  <ng-container *ngIf="block.data.showAllText && block.data.showAllText.length > 1">
                    Story
                  </ng-container>
                  {{currentIndex}} of {{block.content.length}}</div>
            </div>

            <div class="stories-carousel-controls__next"></div>
        </div>
    </div>


    <div class="stories-carousel__show-all" *ngIf="block.data.showAllText && block.data.showAllText.length > 1">
        <a href="{{block.data.showAllLink}}" class="btn btn-primary btn--show-all" [innerHTML]="block.data.showAllText"></a>
    </div>
</div>
